module.exports = __webpack_public_path__ + "img/2024-12-12a_4.5ecdfdf5.jpg";